import axios, { InternalAxiosRequestConfig } from 'axios';

export const xervixApi = axios.create({
  baseURL: process.env.REACT_APP_APPSERVER_API_URL,
  headers: { 'Content-Type': 'application/json', accept: '*/*' },
});

xervixApi.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const xervixApiMultipart = axios.create({
  baseURL: process.env.REACT_APP_APPSERVER_API_URL,
  headers: { 'Content-Type': 'multipart/form-data', accept: '*/*' },
});

xervixApiMultipart.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);